jQuery(document).ready(function($) {

  $('.wp-gallery-slick').each(function() {
    $(this).slick({
      arrows: false,
      dots: true
    });
  });

});
